// quasar-user-options.js
import { Notify, Dialog } from 'quasar'
import 'quasar/dist/quasar.sass'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'

// Adicione aqui outros plugins e componentes que você deseja usar
export default {
  config: {
    brand: {
      primary: '#FF5A00',
      secondary: '#74788d',
      accent: '#386835',
      dark: '#1D1D1D',
      positive: '#34c38f',
      negative: '#f46a6a',
      info: '#31CCEC',
      warning: '#f1b44c'
    }
  },
  plugins: {
    Notify,
    Dialog
  }
}